import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { FaSun, FaMoon, FaSignOutAlt, FaUser } from 'react-icons/fa';

const Navbar = () => {
  const { user, logout } = useAuth();
  const { isDarkMode, toggleTheme } = useTheme();

  const handleLogout = () => {
    logout();
  };

  return (
    <nav className="bg-gradient-to-r from-brand-purple to-brand-red shadow-lg border-b border-white/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Logo and Brand */}
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 rounded-full bg-brand-radial animate-float shadow-lg">
              {/* Placeholder for logo - you can replace with <img src="/logo.png" alt="ZapRF" /> */}
              <div className="w-full h-full rounded-full bg-gradient-to-br from-brand-red to-brand-purple"></div>
            </div>
            <div className="flex items-center space-x-2">
              <h1 className="text-2xl font-bold text-white">
                ZapRF
              </h1>
              <span className="text-white/80 text-sm">License Manager</span>
            </div>
          </div>

          {/* User Actions */}
          <div className="flex items-center space-x-4">
            {user && (
              <div className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
                <FaUser className="text-white/80" />
                <span className="text-white font-medium hidden sm:block">
                  {user.email}
                </span>
              </div>
            )}
            
            {/* Theme Toggle */}
            <button
              onClick={toggleTheme}
              className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-all duration-200 backdrop-blur-sm"
              aria-label="Toggle theme"
            >
              {isDarkMode ? (
                <FaSun className="w-5 h-5 text-yellow-300" />
              ) : (
                <FaMoon className="w-5 h-5 text-white" />
              )}
            </button>

            {/* Logout Button */}
            {user && (
              <button
                onClick={handleLogout}
                className="flex items-center space-x-2 px-4 py-2 bg-white/10 hover:bg-white/20 rounded-full transition-all duration-200 backdrop-blur-sm"
                aria-label="Logout"
              >
                <FaSignOutAlt className="w-4 h-4 text-white" />
                <span className="text-white font-medium hidden sm:block">Logout</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 